var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { ALLViewer } from "@@/Annotation";
import { action, makeObservable, observable } from "mobx";
import { BaseDialogState } from "../UIComponents/BaseDialog";
import { SelectMemberDialogState } from "../UIComponents/SelectMemberDialog";
import { DatasheetTemplate, TemplateStore } from "./TemplateStore";
export class DatasheetDialogState {
    constructor() {
        this.editmode = false;
        this.show = false;
        this.name = "";
        this.editdatasheet = undefined;
        this.letrid = "";
        this.saving = false;
        this.vieweabletoeveryone = true;
        this.templateid = "Blank";
        this.smstate = new SelectMemberDialogState();
        this.savingid = "";
        this.dialog = new BaseDialogState();
        makeObservable(this);
        this.dialog.setHeaderLabel("Datasheet");
        this.dialog.setCancelLabel("Close");
        this.dialog.setOkLabel("Add");
        this.dialog.onOk = () => {
            this.save();
        };
        APPEvent.addSubscriberForAddDatasheet((sh) => {
            if (this.saving && sh.id === this.savingid) {
                this.setSaving(false);
                if (!sh.sh) {
                    APPEvent.publishApperror("Sorry, failed to store datasheet");
                }
                else {
                    this.setShow(false);
                }
            }
        });
        APPEvent.addSubscriberForUpdateDatasheet((sh) => {
            this.setSaving(false);
            if (!sh.ok) {
                APPEvent.publishApperror("Sorry, failed to update datasheet");
            }
            else {
                this.setShow(false);
            }
        });
    }
    setViewableToEveryone(viewable) {
        this.vieweabletoeveryone = viewable;
    }
    moveItemBetween(item, min, max) {
        let rannum = Math.random() * (max - min) + min;
        item.orderindex = rannum;
    }
    setDatasheet(dh) {
        this.editdatasheet = dh;
        if (dh.viewers.indexOf(ALLViewer) !== -1) {
            this.setViewableToEveryone(true);
        }
        else {
            this.setViewableToEveryone(false);
            dh.viewers.forEach((vw) => this.smstate.setSelect(vw, true));
        }
        this.setName(dh.name);
    }
    setName(name) {
        this.name = name;
    }
    addLink(link) {
    }
    setTemplateid(id) {
        this.templateid = id;
    }
    setSaving(saving) {
        this.saving = saving;
    }
    save() {
        var _a, _b;
        if (!this.name) {
            APPEvent.publishApperror("Please enter name for datasheet");
            return;
        }
        this.setSaving(true);
        let viewers = [ALLViewer];
        if (!this.vieweabletoeveryone) {
            viewers = [];
            for (const sid of this.smstate.selectedcontacts) {
                viewers.push(sid);
            }
        }
        const req = {
            id: this.editmode ? (_b = (_a = this.editdatasheet) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : "" : '',
            viewers: viewers,
            letrid: this.letrid,
            authorid: '',
            lastupdatetime: -1,
            updatedby: '',
            name: this.name,
        };
        if (!this.editmode && this.templateid != "Blank") {
            let stype = DatasheetTemplate[this.templateid];
            const shs = TemplateStore.getDatasheetTemplate(stype);
            if (shs) {
                req.schemasunbox = shs;
            }
        }
        const areq = {
            id: Math.random() + "",
            sh: req
        };
        this.savingid = areq.id;
        if (this.editmode) {
            Apphandler.sendMessage("updatedatasheet", areq);
        }
        else {
            Apphandler.sendMessage("adddatasheet", areq);
        }
    }
    reset() {
        this.setShow(false);
        this.setSaving(false);
        this.setName("");
        this.setViewableToEveryone(true);
        this.smstate.reset();
    }
    setShow(show) {
        this.show = show;
        this.dialog.setOpen(show);
    }
    setEditMode(mode) {
        this.editmode = mode;
        if (mode) {
            this.dialog.setOkLabel("Edit");
        }
        else {
            this.dialog.setOkLabel("Add");
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], DatasheetDialogState.prototype, "editmode", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DatasheetDialogState.prototype, "show", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DatasheetDialogState.prototype, "name", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DatasheetDialogState.prototype, "editdatasheet", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DatasheetDialogState.prototype, "saving", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DatasheetDialogState.prototype, "vieweabletoeveryone", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DatasheetDialogState.prototype, "templateid", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DatasheetDialogState.prototype, "setViewableToEveryone", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DatasheetDialogState.prototype, "setDatasheet", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], DatasheetDialogState.prototype, "setName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], DatasheetDialogState.prototype, "setTemplateid", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DatasheetDialogState.prototype, "setSaving", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DatasheetDialogState.prototype, "reset", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DatasheetDialogState.prototype, "setShow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DatasheetDialogState.prototype, "setEditMode", null);
